<template>
  <div id="app" class="theme-transition">
    <div class="scroll-progress" :style="{ width: scrollProgress + '%' }"></div>
    <div class="scroll-progress" :style="{ width: scrollProgress + '%' }"></div>

    <div class="scroll-progress" :style="{ width: scrollProgress + '%' }"></div>

    <!-- <v-btn icon class="theme-toggle" @click="toggleDarkMode">
      <v-icon>{{
        isDark ? "mdi-white-balance-sunny" : "mdi-weather-night"
      }}</v-icon>
    </v-btn> -->

    <router-view />
    <!-- <FAQWidget /> -->
  </div>
</template>

<script setup>
// import { useTheme } from "vuetify";
import { ref, onMounted, onBeforeUnmount, } from "vue";
// import FAQWidget from "./components/FAQWidget.vue";

// const theme = useTheme();
const scrollProgress = ref(0);
// const isDark = ref(localStorage.getItem("theme") === "dark");

// Watch for changes and apply Vuetify theme
// watchEffect(() => {
//   theme.global.name.value = isDark.value
//     ? "myCustomDarkTheme"
//     : "myCustomLightTheme";
// });

// Auto-detect system theme if not saved
onMounted(() => {
  // if (!localStorage.getItem("theme")) {
  //   const prefersDark = window.matchMedia(
  //     "(prefers-color-scheme: dark)"
  //   ).matches;
  //   isDark.value = prefersDark;
  // }

  window.addEventListener("scroll", updateScrollProgress);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", updateScrollProgress);
});

function updateScrollProgress() {
  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  scrollProgress.value = Math.min(
    100,
    Math.max(0, (scrollTop / docHeight) * 100)
  );
}

// function toggleDarkMode() {
//   isDark.value = !isDark.value;
//   localStorage.setItem("theme", isDark.value ? "dark" : "light");
// }
</script>

<style scoped>
.scroll-progress {
  position: fixed;
  top: 0;
  left: 0;
  height: 4px;
  background-color: orange;
  z-index: 9999;
  transition: width 0.1s ease-out;
}
.theme-toggle {
  position: fixed;
  bottom: 90px;
  right: 20px;
  z-index: 10000;
}
</style>
